import { render, staticRenderFns } from "./DialogDeleteEmergencyContact.vue?vue&type=template&id=01cc60d1"
import script from "./DialogDeleteEmergencyContact.vue?vue&type=script&lang=js"
export * from "./DialogDeleteEmergencyContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports